var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"padding-vertical-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-xl-10"},[_c('ul',{staticClass:"grid"},[_vm._l((_vm.eventos),function(event){return [_c('EventoImagen',{key:event.id,attrs:{"event":event}})]})],2)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }